<template>
  <v-server-table
    :columns="columns"
    :options="tableOptions"
    @row-click="redirectToPerson"
    id="peopleTable"
    ref="peopleTable"
    name="peopleTable">

    <span slot="created_at" slot-scope="{row}">
      <span v-if="row.created_at">
        {{ row.created_at | localTime('YYYY-MM-DD HH:mm') }}
      </span>
    </span>

    <span slot="birthdate" slot-scope="{row}">
      <span v-if="row.birthdate">
        {{ row.birthdate | localTime('DD/MM/YYYY') }}
      </span>
    </span>

    <span slot="address" slot-scope="{row}">
      <span v-if="Array.isArray(row.addresses) && row.addresses.length > 0 && row.addresses[0].city">
        {{row.addresses[0].city}}
      </span>
    </span>

  </v-server-table>

</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
export default {
  props: {
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    service: {
      type: Object,
      required: true
    }
  },
  mixins: [
    TableQueryMixin
  ],
  data () {
    return {
      querySearchKey: 0,
      columns: [
        'created_at',
        'name',
        'birthdate',
        'address',
        'phone',
      ],
      queryUrl: `${this.service.url}/admin/people`,
      tableOptions: {
        columnsDropdown: false,
        saveState: true,
        filterable: true,
        sortable: ['created_at', 'birthdate', 'name'],
        headings: {
          created_at: this.$t('tables.columns.created_at'),
          name: this.$t('tables.columns.name'),
          birthdate: this.$t('tables.columns.birthdate'),
          phone: this.$t('tables.columns.contact'),
          address: this.$t('tables.columns.address')
        },
        columnsClasses: {
          results: 'results',
          actions: 'actions',
        }
      }
    }
  },
  methods: {
    redirectToPerson: function ({ row }) {
      this.$emit('row-clicked', { person: row })
    },
    reloadTable: function () {
      this.getTableReference().refresh()
    },
    getTableReference: function () {
      return this.$refs.peopleTable
    }
  },
  watch: {
    querySearch: function (value) {
      this.querySearchKey = ++this.querySearchKey
      if (this.querySearchKey > 1) {
        this.getTableReference().setFilter(value)
      }
    }
  },
  filters: {
    parseBirthdate: function (value) {
      if (!value || value === '') return ''
      let date = this.moment(value, 'YYYY-MM-DD HH:mm:ss')
      return date.isValid() ? date.format('DD/MM/YYYY') : ''
    }
  }
}
</script>

<style lang="scss">
  #peopleTable{
    .VueTables__search {
      display: none;
    }
  }
</style>
